/* Bebeomi cart drawer suggestions: add single-variant products straight from the drawer. */
if (!window.bebeomiCartSuggestions) {
  window.bebeomiCartSuggestions = true;
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-suggestion-add]');
    if (!button || button.getAttribute('aria-busy') === 'true') return;
    event.preventDefault();

    const drawer = document.querySelector('cart-drawer');
    const sections = drawer?.getSectionsToRender ? drawer.getSectionsToRender().map((s) => s.id) : [];
    button.setAttribute('aria-busy', 'true');

    fetch(`${window.routes?.cart_add_url || '/cart/add'}.js`.replace('.js.js', '.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(button.dataset.suggestionAdd), quantity: 1 }],
        sections,
        sections_url: window.location.pathname,
      }),
    })
      .then((response) => response.json())
      .then((state) => {
        if (state.status) throw new Error(state.description || state.message);
        if (drawer && state.sections) {
          drawer.renderContents(state);
        } else {
          window.location.href = window.routes?.cart_url || '/cart';
        }
      })
      .catch(() => {
        button.removeAttribute('aria-busy');
        window.location.href = button.closest('.b-cart-suggestions__card')?.querySelector('a')?.href || '/cart';
      });
  });
}
